import { render, staticRenderFns } from "./SubAgentPerformancePage.vue?vue&type=template&id=5c5166ca&scoped=true"
import script from "./SubAgentPerformancePage.vue?vue&type=script&lang=js"
export * from "./SubAgentPerformancePage.vue?vue&type=script&lang=js"
import style0 from "./SubAgentPerformancePage.vue?vue&type=style&index=0&id=5c5166ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5166ca",
  null
  
)

export default component.exports